module.exports = __webpack_public_path__ + "static/media/multi_step_image.79e916ae.png";